<div class="card">

  <div class="data-header">

    <button mat-raised-button color="primary" (click)="openDialog()">
      Nouveau poste
    </button>

    <mat-form-field class="filter-field">
      <mat-label>Filtre</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Libellé du poste...">
    </mat-form-field>

  </div>

  <mat-table
    class="mat-elevation-z8 table-container"
    [dataSource]="dataSource"
    matSort
    (matSortChange)="announceSortChange($event)">

    <!-- Libellé -->
    <ng-container matColumnDef="libelle">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Libellé</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.libelle }}</mat-cell>
    </ng-container>

    <!-- Statut -->
    <ng-container matColumnDef="active">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Statut</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="status-badge" [ngClass]="row.active ? 'status-active' : 'status-inactive'">
          {{ row.active ? 'Actif' : 'Inactif' }}
        </span>
      </mat-cell>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef class="actions-td">Actions</mat-header-cell>
      <mat-cell *matCellDef="let row" class="actions-td">

        <button mat-icon-button
                (click)="openDialog(row)"
                matTooltip="Modifier"
                color="primary">
          <mat-icon>mode_edit</mat-icon>
        </button>

        <button mat-icon-button
                (click)="deletePoste(row)"
                matTooltip="Supprimer"
                color="warn">
          <mat-icon>delete</mat-icon>
        </button>

      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
        <mat-icon>search_off</mat-icon>
        Aucun poste trouvé
      </td>
    </tr>

  </mat-table>
</div>